import React, { useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';

const RedirectToLoginRule = () => {
  const history = useHistory();

  useEffect(() => {
    localStorage.setItem(
      'lastLocation',
      JSON.stringify(history.location.pathname + history.location.search),
    );
    history.replace('/login');
  }, [history]);

  return null;
};

export default RedirectToLoginRule;
